var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"text-sm"},[_c('p',{staticClass:"font-bold mt-0 mb-1",domProps:{"textContent":_vm._s(_vm.alertText)}}),_vm._v(" "),_c('p',{staticClass:"mt-0",domProps:{"textContent":_vm._s(_vm.alertSecondary)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }